<template>
  <div>
    <div class="reward-details" v-if="reward !== null">
      <div class="reward-details__breadcrumbs" v-if="!$root.isMobile">
        <span @click.stop="onMarket">Маркет</span> / Скидки
      </div>
      <div class="reward-details__image-info">
        <div class="reward-details__image">
          <img :src="reward.images ? ($root.isMobile ? reward.images.mobile : reward.images.desktop) : ''" />
          <div class="reward-details__back" v-if="$root.isMobile && !isMobileApp">
            <Button
              variant="secondary"
              :size="$root.isMobile ? 'sm' : 'lg'"
              shape="circle"
              iconLeft="left"
              mobile
              @click="onBack"
            ></Button>
          </div>
        </div>
        <div class="divider reward-details__divider" v-if="$root.isMobile"></div>
        <div class="reward-details__info">
          <div>
            <div class="info__heading" v-html="reward.name || ''"></div>
            <div class="info__subheading" v-html="reward.subTitle || ''"></div>
          </div>
          <div class="info__count" v-if="!$root.isMobile && isSmallQuantity() && reward.promocodeQty > 0">Осталось {{ this.reward.promocodeQty || '-' }} шт.</div>
          <div class="info__price-count" v-if="$root.isMobile">
            <div class="info__price">
              <img :src="coin" width="32" height="32" /><span v-html="reward.priceInPoints || ''"></span>
            </div>
            <div class="info__count" v-if="isSmallQuantity() && reward.promocodeQty > 0">Осталось {{ this.reward.promocodeQty || '-' }} шт.</div>
          </div>
          <div class="info__button">
            <div class="info__price" :class="{ 'price--grayscale': isOutOfStock || availiblelimit === 0 }" v-if="!$root.isMobile">
              <img :src="coin" width="32" height="32" /><span v-html="reward.priceInPoints || ''"></span>
            </div>
            <Button
              v-if="!$root.isMobile || ($root.isMobile && backendMessage === '')"
              variant="primary"
              size="lg"
              :text="(isOutOfStock || isRewardDisabled) ? 'Нет в наличии' : (availiblelimit === 0 ? 'Лимит на покупку' : 'Купить за баллы')"
              :wide="$root.isMobile"
              :disabled="loading || isOutOfStock || isRewardDisabled || backendMessage !== '' || availiblelimit === 0"
              :loading="loading"
              mobile
              @click="onShowConfirm"
            ></Button>
            <Alert
              v-if="backendMessage"
              :text="backendMessage"
              state="warning"
              no-action
            />
          </div>
        </div>
      </div>
      <div v-if="reward.raffleOn && reward.type === 'Prize'" class="reward-details__raffle">
        <div class="reward-details__raffle-item">
          <Icon name="calendar" size="l" />
          <span>Розыгрыш {{ formatDate(reward.raffleOn) }}</span>
        </div>
      </div>

      <div class="divider reward-details__divider" v-if="$root.isMobile"></div>
      <div class="reward-details__description">
        <Tabs
          v-if="!$root.isMobile"
          class="description__tabs"
          :items="tabs"
          :activeItem="selectedTab"
          @changed="onChangeTab"
        />
        <div class="divider" v-if="!$root.isMobile"></div>
        <div class="description__title" v-if="$root.isMobile">Описание</div>
        <div class="description__title-partner" v-if="isVisible(0)">
          <div :class="{ 'w-100': !hasPartner }">
            <div class="description__text" v-html="reward.description || ''" ref="rewardDescriptionBlock"></div>
            <div class="description__partner-link" v-if="reward.descriptionUrl">
              <Link v-if="!isMobileApp" variant="primary" size="md" icon-left="externa-link" tag="a" :href="reward.descriptionUrl || ''" target="_blank">Подробнее на сайте партнёра</Link>
              <Link v-if="isMobileApp" variant="primary" size="md" icon-left="externa-link" @click.stop=onRewardExternalLink(reward.descriptionUrl)>Подробнее на сайте партнёра</Link>
            </div>
          </div>
          <div class="description__partner" v-if="hasPartner">
            <div class="description__partner-logo" v-if="reward.partner.logos"><img :src="$root.isMobile ? reward.partner.logos.mobile : reward.partner.logos.desktop" /></div>
            <div class="description__partner-name" v-else v-html="reward.partner.name || ''"></div>
            <Link v-if="!isMobileApp" variant="secondary" size="sm" icon-left="externa-link" tag="a" :href="reward.partner.url || ''" target="_blank">Информация о партнёре</Link>
            <Link v-if="isMobileApp" variant="secondary" size="sm" icon-left="externa-link" @click.stop=onRewardExternalLink(reward.partner.url)>Информация о партнёре</Link>
          </div>
        </div>
        <div class="description__title" v-if="$root.isMobile">Как оплатить и получить </div>
        <div class="description__pay-get" v-if="isVisible(1)">
          <div class="description__text" v-html="reward.howToGet || ''" ref="rewardHowToBlock"></div>
        </div>
      </div>
    </div>

    <Modal
      v-if="reward !== null"
      name="reward-confirm"
      :img="coin"
      title="С вашего счета будет списано"
      :subtitle="`${reward.priceInPoints || ''} баллов`"
      :active="showConfirm"
      :class="{ 'for-mobile-app show-modal-close': isMobileApp }"
      :noTransition="true"
      @close.prevent="onConfirmClose"
    >
      <div class="buttons-group">
        <div class="buttons-group__item">
          <Button
            variant="primary"
            size="lg"
            text="Подтвердить покупку"
            @click="onBuy"
            :loading="loading"
            :disabled="loading"
            wide
            mobile
          ></Button>
        </div>
        <div class="buttons-group__item buttons-group__item_first">
          <Button
            variant="secondary"
            size="lg"
            text="Отменить"
            @click="onConfirmClose"
            :loading="loading"
            :disabled="loading"
            wide
            mobile
          ></Button>
        </div>
      </div>
    </Modal>

    <Modal
      v-if="reward !== null"
      name="reward-bought"
      state="success"
      title="Спасибо за покупку!"
      :subtitle="computedSubtitle"
      :active="showBought"
      :class="{ 'for-mobile-app show-modal-close': isMobileApp }"
      :noTransition="true"
      @close.prevent="onBoughtClose"
      class="bought"
    >
      <div v-if="reward.type !== 'Nordski'" class="reward-bought__promocode" >
        <span v-for="item in code" :key="item.promocodeId">{{ item.code }}</span>
      </div>
      <div v-if="reward.type !== 'Nordski'" class="reward-bought__message text-left" v-html="steps" ref="rewardBoughtSteps"></div>
      <div v-else class="reward-bought__message text-left reward-bought__message_nordski" ref="rewardBoughtSteps">
        Если баллы не зачисляются, <span @click.stop="onSupport">напишите в поддержку</span>
      </div>
      <div class="buttons-group">
        <div v-if="showGoToPartnerButton  && !showWelcomeButtons" class="buttons-group__item">
          <Button
            v-if="!isMobileApp"
            variant="primary"
            size="lg"
            text="На сайт партнёра"
            iconRight="externa-link"
            tag="a"
            target="_blank"
            :href="reward.partner.url"
            wide
            mobile
          ></Button>
          <Button
            v-if="isMobileApp"
            variant="primary"
            size="lg"
            text="На сайт партнёра"
            iconRight="externa-link"
            @click="onRewardExternalLink(reward.partner.url)"
            wide
            mobile
          ></Button>
        </div>
        <div v-if="showWelcomeButtons" class="buttons-group__item">
          <Button
            variant="primary"
            size="lg"
            text="Продолжить покупки"
            @click="onGoMarket"
            wide
            mobile
          ></Button>
        </div>
        <div v-if="!showWelcomeButtons && reward.type !== 'Nordski'" class="buttons-group__item buttons-group__item_first">
          <Button
            variant="secondary"
            size="lg"
            text="История покупок"
            @click="onGoHistory"
            wide
            mobile
          ></Button>
        </div>
        <div v-if="reward.type === 'Nordski'" class="buttons-group__item buttons-group__item_first">
          <Button
            variant="primary"
            size="lg"
            text="Проверить зачисление"
            iconRight="externa-link"
            wide
            mobile
            tag="a"
            href="https://russiarunning.com/profile"
            target="_blank"
          ></Button>
        </div>
      </div>
    </Modal>

    <Modal
      v-if="reward !== null"
      name="reward-confirm"
      title="Укажите кол-во"
      :subtitle="`Вам доступно ${availiblelimit || 0 } шт. для покупки`"
      :active="showPromocodesCount"
      :class="{ 'for-mobile-app show-modal-close': isMobileApp }"
      :noTransition="true"
      @close.prevent="onPromocodesCountsClose"
    >
      <div class="reward-details__count">
        <Button
          variant="secondary"
          size="lg"
          text=""
          @click="onDiminishCount"
          :loading="loading"
          :disabled="promocodesCount < 1"
        >
          <Icon name="minus" size="s"></Icon>
        </Button>
        <div class="reward-details__count-input">
          <Input
            v-model="promocodesCount"
            id="email"
            name="email"
            readonly
          ></Input>
        </div>
        <Button
          variant="secondary"
          size="lg"
          text=""
          @click="onAddCount"
          :loading="loading"
          :disabled="loading || promocodesCount >= availiblelimit"
        >
          <Icon name="plus" size="s"></Icon>
        </Button>
      </div>
      <div class="reward-details__button">
        <Button
          variant="primary"
          size="lg"
          :text="`Купить за ${reward.priceInPoints * promocodesCount} ${getPointsLabel(reward.priceInPoints * promocodesCount)}`"
          :loading="loading"
          :disabled="loading || promocodesCount < 1"
          @click="onBuy"
          mobile
        ></Button>
      </div>
    </Modal>

    <Modal
      v-if="reward !== null"
      name="expectation"
      title="Проверяем условия"
      :img="sendClock"
      :active="showExpectation"
      :class="{ 'for-mobile-app show-modal-close': isMobileApp }"
      :noTransition="true"
      @close.prevent="onExpectationClose"
    >
      <div class="reward-details__loader">
        <Loader/>
      </div>
      <div class="reward-bought__message text-left">
        <ul>
          <li><span>1.</span><div>Наличие регистрации на платформе <Link href="https://reg.russiarunning.com/" variant="primary" target="_blank">RussiaRunning</Link>.</div></li>
          <li><span>2.</span><div>Подключение программы лояльности <Link href="https://nordski.russiarunning.com/" variant="primary" target="_blank">NORDSKI</Link> в личном кабинете платформы Russia Running.</div></li>
          <li><span>3.</span><div>Совпадение ФИО участника и адреса электронной почты в личных кабинетах спортивной программы Russia Running и <Link href="https://nordski.russiarunning.com/" variant="primary" target="_blank">NORDSKI</Link>.</div></li>
        </ul>
      </div>
    </Modal>

    <Modal
      v-if="reward !== null"
      name="reward-bought-error"
      title="Покупка не удалась"
      subtitle="Ваши баллы не будут списаны. <br>Проверьте, что все условия выполнены"
      state="warning"
      :active="rewardBoughtError"
      :class="{ 'for-mobile-app show-modal-close': isMobileApp }"
      :noTransition="true"
      @close.prevent="onRewardBoughtErrorClose"
      class="reward-details__modal-error"
    >
      <div class="reward-bought__message text-left reward-bought__message_nordski">
        <ul>
          <li><span>1.</span><div>Наличие регистрации на платформе <Link href="https://reg.russiarunning.com/" variant="primary" target="_blank">RussiaRunning</Link>.</div></li>
          <li><span>2.</span><div>Подключение программы лояльности <Link href="https://nordski.russiarunning.com/" variant="primary" target="_blank">NORDSKI</Link> в личном кабинете платформы Russia Running.</div></li>
          <li><span>3.</span><div>Совпадение ФИО участника и адреса электронной почты в личных кабинетах спортивной программы Russia Running и <Link href="https://nordski.russiarunning.com/" variant="primary" target="_blank">NORDSKI</Link>.</div></li>
        </ul>
      </div>
      <div class="buttons-group">
        <Button
          variant="secondary"
          size="lg"
          text="Начать заново"
          :loading="loading"
          :disabled="loading"
          wide
          mobile
          @click="onRewardBoughtErrorClose"
        ></Button>
      </div>
    </Modal>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Alert from '@rr-component-library/alert/src/main';
import Input from '@rr-component-library/input/src/main';
import dayjs from 'dayjs';
import { getArticleByKey } from '@/assets/js/helpers';
import Coin from '@/assets/img/coin.svg';
import sendClock from '@/assets/icons/send-clock.svg';

const { v4: uuidv4 } = require('uuid');

const TPL_NOT_ENOUGH_POINTS = 'Для покупки не хватает <b>{0}</b> {1}. <br><a href="{{articleAboutTasks}}" target="_blank" rel="noopener noreferrer">Как заработать?</a>';
const TPL_PURCHASE_LIMIT = 'Извините, данное поощрение можно приобрести только {0} раз(а). Ранее вы его уже приобрели. Можете выбрать другие поощрения в <a href="{{marketLink}}">Маркете</a>.';

export default {
  name: 'RewardDetails',
  components: {
    Alert,
    Input,
  },
  data() {
    return {
      reward: null,
      promotionId: null,
      coin: Coin,
      sendClock,
      tabs: [
        { title: 'Описание', enabled: true },
        { title: 'Как оплатить и получить', enabled: true },
      ],
      selectedTab: 0,
      promocodesCount: 1,
      showConfirm: false,
      showBought: false,
      showPromocodesCount: false,
      showExpectation: false,
      rewardBoughtError: false,
      code: '',
      steps: '',
      errorMessages: {
        not_enough_points_to_buy: TPL_NOT_ENOUGH_POINTS,
        purchase_limit_on_participant_reached: TPL_PURCHASE_LIMIT,
      },
      showError: false,
      backendMessage: '',
      loading: false,
      isPromocode: false,
    };
  },
  computed: {
    ...mapGetters('settings', ['themeDone', 'resources', 'options']),
    ...mapGetters('wallet', ['balance']),
    ...mapGetters('market', ['promotion', 'promocode', 'purchaseId', 'responseStatus', 'errorCode', 'availiblelimit']),
    ...mapGetters('user', ['isMobileApp']),
    ...mapGetters('content', ['articles']),
    computedSubtitle() {
      return this.reward.type !== 'Nordski'
        ? 'Ваш промокод для получения товара:'
        : 'Баллы начислятся в течение нескольких минут. <br> Проверьте личный кабинет RussiaRunning';
    },
    hasPartner() {
      if (!this.reward) return false;
      if (this.reward.partner) return true;
      return false;
    },
    rewardDescription() {
      if (!this.reward) return '';
      if (this.reward.description) return this.reward.description;
      return '';
    },
    isOutOfStock() {
      if (!this.reward) return false;
      if (this.reward.promocodeQty !== undefined && this.reward.promocodeQty <= 0) {
        return true;
      }
      if (this.reward.state === 'Disabled') {
        return true;
      }
      if (this.errorCode === 'no_avaliable_promocodes') {
        return true;
      }
      return false;
    },

    isRewardDisabled() {
      if (!this.reward) return false;
      if (this.reward.disabledOn) return true;
      return false;
    },
    showGoToPartnerButton() {
      return this.reward ? this.reward.type === 'Discount' || this.reward.type === 'Promocode' : false;
    },
    hasNordski() {
      if (!this.reward) return false;
      if (this.reward.type === 'Nordski') return true;
      return false;
    },
    showWelcomeButtons() {
      return this.options ? this.options.showWelcomeButtons === true : false;
    },
    articleAboutTasks() {
      const link = getArticleByKey(this.articles, 'key_4');
      return link || '#';
    },
    marketLink() {
      return this.isMobileApp ? '/goPage?name=Market&path=/market?title=Маркет&addToHistory=true' : '/market';
    },
  },
  watch: {
    themeDone(val) {
      if (val) {
        this.errorMessages.not_enough_points_to_buy = this.replaceVariables(TPL_NOT_ENOUGH_POINTS);
        this.errorMessages.purchase_limit_on_participant_reached = this.replaceVariables(TPL_PURCHASE_LIMIT);
        this.$nextTick(() => {
          setTimeout(() => { this.setLinkListeners(); }, 150);
        });
      }
    },
    articles() {
      if (this.themeDone) {
        this.errorMessages.not_enough_points_to_buy = this.replaceVariables(TPL_NOT_ENOUGH_POINTS);
        this.errorMessages.purchase_limit_on_participant_reached = this.replaceVariables(TPL_PURCHASE_LIMIT);
        if (this.backendMessage && this.reward) {
          if (this.errorCode === 'not_enough_points_to_buy' && this.balance) {
            const coins = Math.abs(this.balance.amount - this.reward.priceInPoints);
            this.backendMessage = this.errorMessages.not_enough_points_to_buy
              .replace('{0}', String(coins))
              .replace('{1}', this.getPointsLabel(coins));
          }
          if (this.errorCode === 'purchase_limit_on_participant_reached') {
            const count = this.reward.limitOnParticipant || 1;
            this.backendMessage = this.errorMessages.purchase_limit_on_participant_reached.replace('{0}', String(count));
          }
        }
      }
      this.$nextTick(() => {
        setTimeout(() => { this.setLinkListeners(); }, 150);
      });
    },
    rewardDescription(val) {
      if (val) {
        setTimeout(() => { this.setLinkListeners(); }, 100);
      }
    },
  },
  methods: {
    ...mapActions('wallet', ['getBalance']),
    ...mapActions('market', ['getPromotion', 'getPromocodes', 'buyPromotion', 'getPromotionAvailibleLimit']),
    onSupport() {
      if (this.isMobileApp) {
        this.$root.$goPage('Support', '/support?title=Поддержка');
        return;
      }
      this.onBoughtClose();
      setTimeout(() => {
        this.$router.push({ name: 'Support' }).catch(() => {});
      }, 200);
    },
    getPointsLabel(points) {
      const lastDigit = points % 10;
      const lastTwoDigits = points % 100;

      if (lastTwoDigits >= 11 && lastTwoDigits <= 19) {
        return 'баллов';
      }

      if (lastDigit === 1) {
        return 'балл';
      }

      if (lastDigit >= 2 && lastDigit <= 4) {
        return 'балла';
      }

      return 'баллов';
    },
    onGoMarket() {
      this.onBoughtClose();
      if (this.isMobileApp) {
        const p = this.$route.query.p ? `&p=${this.$route.query.p}` : '';
        setTimeout(() => { this.$root.$goPage('Market', `/market?title=Маркет${p}&addToHistory=true`); }, 200);
        return;
      }
      const query = this.$route.query.p ? { p: this.$route.query.p } : {};
      setTimeout(() => { this.$router.push({ name: 'Market', query }).catch(() => {}); }, 200);
    },
    onRewardExternalLink(url) {
      if (!url) return;
      this.$root.$openInExternal(url, `${window.location.pathname}?id=${this.$route.query.id}`);
    },
    onBack() {
      const from = this.$route.query.from || '';
      if (from) {
        this.$router.push({ name: from, query: this.isMobileApp ? { addToHistory: 'true' } : {} }).catch(() => {});
        return;
      }
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else {
        const query = {};
        if (this.$route.query.p) query.p = this.$route.query.p;
        if (this.isMobileApp) query.addToHistory = 'true';
        this.$router.push({ name: 'Market', query }).catch(() => {});
      }
    },
    onMarket() {
      const query = {};
      if (this.$route.query.p) query.p = this.$route.query.p;
      if (this.$route.query.category) query.category = this.$route.query.category;
      if (this.isMobileApp) {
        query.addToHistory = 'true';
      }
      if (this.$route.query.catOne && this.$route.query.catTwo) {
        this.$router.push({ name: 'MarketCategoryTwo', params: { catOne: this.$route.query.catOne, catTwo: this.$route.query.catTwo }, query }).catch(() => {});
        return;
      }
      if (this.$route.query.catOne) {
        this.$router.push({ name: 'MarketCategoryOne', params: { catOne: this.$route.query.catOne }, query }).catch(() => {});
        return;
      }
      this.$router.push({ name: 'Market', query }).catch(() => {});
    },
    onShowConfirm() {
      if (this.loading) return;
      if (this.reward.limitOnParticipant === 1) {
        // window.location.hash = '#!showConfirm=true';
        this.showConfirm = true;
      } else {
        this.getPromotionAvailibleLimit(this.promotionId)
          .then(() => {
            // window.location.hash = '#!showPromocodesCount=true';
            this.showPromocodesCount = true;
            this.promocodesCount = 1;
          });
      }
    },
    onshowExpectation() {
      this.showExpectation = true;
    },
    onExpectationClose() {
      this.showExpectation = false;
    },
    showRewardBoughtError() {
      this.rewardBoughtError = true;
    },
    onRewardBoughtErrorClose() {
      this.rewardBoughtError = false;
    },
    onAddCount() {
      if (this.promocodesCount < this.availiblelimit) {
        this.promocodesCount += 1;
      }
    },
    onDiminishCount() {
      if (this.promocodesCount > 0) {
        this.promocodesCount -= 1;
      }
    },
    onConfirmClose() {
      this.$root.$setLocationHash('');
      this.showConfirm = false;
    },
    onPromocodesCountsClose() {
      this.$root.$setLocationHash('');
      this.showPromocodesCount = false;
    },
    async pollPromocodes(attempts) {
      if (attempts === 0) {
        return;
      }
      if (this.$route.name !== 'RewardDetails') {
        return;
      }
      await this.getPromocodes({ purchaseId: this.purchaseId, purchasedPromocodeNumber: this.promocodesCount })
        .then(() => {
          if (this.responseStatus === 404) {
            setTimeout(() => {
              this.pollPromocodes(attempts - 1);
            }, 1000);
          } else if (this.responseStatus === 409 && this.errorCode === 'purchase_rejected') {
            this.showRewardBoughtError();
          } else {
            this.code = this.promocode;
            this.onShowBought();
          }
          this.getBalance();
          this.getPromotion(this.promotionId)
            .then(() => {
              this.reward = this.promotion;
              setTimeout(() => {
                if (this.$route.name !== 'RewardDetails') {
                  return;
                }
                this.loading = false;
              }, 500);
            });
        });
    },
    onBuy() {
      if (this.promotionId && !this.loading) {
        const purchaseId = uuidv4();
        this.backendMessage = '';
        this.onConfirmClose();
        this.onPromocodesCountsClose();
        this.loading = true;
        this.getPromotion(this.promotionId)
          .then(() => {
            if (this.responseStatus === 200) {
              this.reward = this.promotion;
              if (this.isOutOfStock) {
                this.loading = false;
                return;
              }
              this.buyPromotion({ promotionId: this.promotionId, purchaseId, promocodesNumber: this.promocodesCount })
                .then(() => {
                  if (this.responseStatus === 200) {
                    this.pollPromocodes(20);
                  } else if (this.responseStatus === 409) {
                    this.setErrorMessage(this.errorCode);
                    this.loading = false;
                  } else {
                    this.backendMessage = `Произошла ошибка: ${this.responseStatus}`;
                    this.loading = false;
                  }
                });
              return;
            }
            this.loading = false;
          });
      }
    },
    onBuyNordski() {
      if (this.promotionId && !this.loading) {
        const purchaseId = uuidv4();
        this.backendMessage = '';
        this.onConfirmClose();
        this.onPromocodesCountsClose();
        this.onshowExpectation();
        this.loading = true;
        this.buyPromotion({ promotionId: this.promotionId, purchaseId, promocodesNumber: this.promocodesCount })
          .then(() => {
            if (this.responseStatus === 200) {
              setTimeout(() => {
                this.onExpectationClose();
                this.onShowBought();
              }, 2000);
            } else if (this.responseStatus === 409) {
              this.setErrorMessage(this.errorCode);
              this.loading = false;
            } else {
              this.backendMessage = `Произошла ошибка: ${this.responseStatus}`;
              this.loading = false;
            }
          });
      }
    },
    onShowBought() {
      // window.location.hash = '#!showBought=true';
      this.showBought = true;
    },
    onBoughtClose() {
      this.$root.$setLocationHash('');
      this.showBought = false;
    },
    onGoHistory() {
      this.onBoughtClose();
      if (this.isMobileApp) {
        setTimeout(() => { this.$root.$goPage('SettingsHistory', '/my-settings/purchase-history?title=Мой аккаунт&addToHistory=true'); }, 250);
        return;
      }
      setTimeout(() => { this.$router.push({ name: 'SettingsHistory' }).catch(() => {}); }, 250);
    },
    onChangeTab(index) {
      this.selectedTab = index;
    },
    isVisible(selectedTab) {
      if (this.$root.isMobile) return true;
      if (selectedTab === this.selectedTab) return true;
      return false;
    },
    isSmallQuantity() {
      if (!this.reward) return false;
      return this.reward.promocodeQty <= 5;
    },
    setErrorMessage(errorCode) {
      if (!this.reward) return;
      if (errorCode === 'not_enough_points_to_buy') {
        const coins = Math.abs(this.balance.amount - this.reward.priceInPoints);
        const message = this.errorMessages.not_enough_points_to_buy;
        if (!message) return;
        this.backendMessage = message
          .replace('{0}', String(coins))
          .replace('{1}', this.getPointsLabel(coins));
        return;
      }
      if (errorCode === 'purchase_limit_on_participant_reached') {
        const message = this.errorMessages.purchase_limit_on_participant_reached;
        if (!message) return;
        const count = this.reward ? this.reward.limitOnParticipant || 1 : 1;
        this.backendMessage = message.replace('{0}', count);
        return;
      }
      this.backendMessage = 'Произошла ошибка';
    },
    setSteps() {
      if (!this.reward) return;
      this.steps = this.reward.howToGet || '';
    },
    replaceVariables(text) {
      if (!text) return '';
      const vars = [
        { id: 'articleAboutTasks', value: this.articleAboutTasks },
        { id: 'marketLink', value: this.marketLink },
      ];
      let result = text;
      for (let i = 0; i < vars.length; i += 1) {
        result = result.replaceAll(`{{${vars[i].id}}}`, vars[i].value);
      }
      return result;
    },
    formatDate(datePrize) {
      const date = dayjs(datePrize).format('DD.MM.YYYY');
      return date;
    },
    setLinkListeners() {
      if (!this.isMobileApp) return;

      const {
        rewardDescriptionBlock,
        rewardHowToBlock,
        rewardBoughtSteps,
      } = this.$refs;
      const blocks = [rewardDescriptionBlock, rewardHowToBlock, rewardBoughtSteps];

      for (let i = 0; i < blocks.length; i += 1) {
        if (!blocks[i]) continue;
        const links = blocks[i].querySelectorAll('a');
        this.setListeners(links);
      }
    },
    setListeners(links) {
      for (let i = 0; i < links.length; i += 1) {
        const href = links[i].getAttribute('href');
        links[i].addEventListener('click', () => {
          this.$root.$openInExternal(href, `${window.location.pathname}?id=${this.$route.query.id}`);
        });
        links[i].setAttribute('href', '#');
        links[i].setAttribute('target', '');
      }
    },
  },
  mounted() {
    if (!this.$route.query.id) {
      this.$router.push({ name: 'Market', query: this.isMobileApp ? { title: 'Маркет', addToHistory: 'true' } : {} }).catch(() => {});
      return;
    }
    if (this.themeDone) {
      this.errorMessages.not_enough_points_to_buy = this.replaceVariables(TPL_NOT_ENOUGH_POINTS);
      this.errorMessages.purchase_limit_on_participant_reached = this.replaceVariables(TPL_PURCHASE_LIMIT);
    }
    this.getPromotion(this.$route.query.id)
      .then(() => {
        if (this.responseStatus === 200) {
          this.reward = this.promotion;
          this.promotionId = this.$route.query.id;
          this.getPromotionAvailibleLimit(this.promotionId);
          this.setSteps();
          this.$nextTick(() => {
            setTimeout(() => { this.setLinkListeners(); }, 200);
          });
        } else {
          this.reward = null;
          this.promotionId = null;
          this.$router.push({ name: 'Market', query: this.isMobileApp ? { title: 'Маркет', addToHistory: 'true' } : {} }).catch(() => {});
        }
      });
  },
};
</script>

<style lang="scss" scoped>
  @import './RewardDetails';
</style>
